<template>
	<div class="display-flex flex-column width-100 height-100 flex-justify-space-between">
		<div class="height-100">
			<div class="tabs-container width-100 display-flex flex-row flex-align-center mb-3">
				<div class="width-100" :key="i" v-for="(tab, i) in filteredTabs">
					<router-link active-class="active" :to="{ name: tab.routeName }" class="tab-button flex-centerize width-100">
						{{ tab.title }}
					</router-link>
				</div>
			</div>
			<div class="menu-inner-content-container pt-2" :class="{ 'full-page': fullPage, 'placement-mode': isPlacementMode }">
				<v-slide-x-transition mode="out-in">
					<component v-if="activeTab?.explanationComponent" class="pa-1 mr-1" :is="activeTab.explanationComponent" />
				</v-slide-x-transition>
				<v-slide-x-transition mode="out-in">
					<component v-if="activeTab?.component" class="mt-3" v-on="$listeners" :is="activeTab.component" />
				</v-slide-x-transition>
			</div>
		</div>
		<AnemicButton v-if="!isPlacementMode && canCreateNewSpace" @click="createNewProject" tile class="create-new-project-button width-100">
			+ New Space
		</AnemicButton>
	</div>
</template>

<script>
import { mapGettersShorthand } from '@/store/utils/mappers';
import { PLACEMENT_MODE_NAME } from '@/router/router.const.js';
import { AccountPermissions } from '@ply-io/ply-front-shared-utilities';
import { isPlacementModeEnabled } from '@/store/modules/featureFlags/getters.js';
import { hasAccountPermission } from '@/store/modules/account/getters.js';
import SpaceTabExplanation from '@/components/ProjectMenu/SpaceTabExplanation.vue';
import ProjectTabMenuContent from '@/components/ProjectMenu/ProjectTabMenuContent.vue';
import PlacementTabExplanation from '@/components/ProjectMenu/PlacementTabExplanation.vue';
import PlacementTabMenuContent from '@/components/ProjectMenu/PlacementTabMenuContent.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
export default {
	name: 'ProjectMenu',
	components: {
		SpaceTabExplanation,
		ProjectTabMenuContent,
		PlacementTabMenuContent,
		PlacementTabExplanation,
	},
	props: {
		fullPage: { type: Boolean },
	},
	computed: {
		...mapGettersShorthand({ isPlacementModeEnabled, hasAccountPermission }),
		tabs() {
			return [
				{
					title: 'By placement',
					routeName: PLACEMENT_MODE_NAME,
					component: PlacementTabMenuContent,
					hidden: !this.isPlacementModeEnabled,
					explanationComponent: PlacementTabExplanation,
				},
				{
					title: 'By space',
					routeName: 'ProjectsRoot',
					component: ProjectTabMenuContent,
					explanationComponent: SpaceTabExplanation,
				},
			];
		},
		filteredTabs() {
			return this.tabs.filter(({ hidden }) => !hidden);
		},
		activeTab() {
			return this.filteredTabs.find((tab) => this.isTabActive(tab));
		},
		isPlacementMode() {
			return this.isTabActive({ routeName: PLACEMENT_MODE_NAME });
		},
		canCreateNewSpace() {
			return this.hasAccountPermission(AccountPermissions.CreateProjects);
		},
	},
	methods: {
		createNewProject() {
			AppDialogManagerService.openNewProjectDialog();
		},
		isTabActive(tab) {
			return this.$route.name === tab.routeName || this.$route.matched.some((r) => r.name === tab.routeName);
		},
	},
};
</script>

<style scoped lang="scss">
.tab-button {
	height: 24px;
	padding: 0px;
	display: flex;
	font-size: 14px;
	color: #969cae;
	border-radius: 0px;
	font-weight: normal;
	text-transform: none;
	text-decoration: none;
	background: var(--white);
	&:hover {
		&:not(.active) {
			background: #f9f9f9;
		}
	}
	&.active {
		color: #6f6bdc;
		background: #f4f5f6;
	}
}
.tabs-container {
	overflow: hidden;
	border-radius: 4px;
	border: 1px solid #e5e5e5;
}
$create-new-space-button-height: 24px;
.create-new-project-button {
	font-size: 14px !important;
	color: #969cae !important;
	border-radius: 4px !important;
	letter-spacing: 0px !important;
	background: var(--white) !important;
	border: 1px solid #969cae !important;
	height: $create-new-space-button-height !important;
}
.menu-inner-content-container {
	overflow-y: auto;
	max-height: 310px;
	&.full-page {
		max-height: calc(100vh - 180px);
	}
	&.placement-mode {
		max-height: calc(310px + #{$create-new-space-button-height});
		&.full-page {
			max-height: calc(100vh - (180px - #{$create-new-space-button-height}));
		}
	}
}
</style>
